export const initialUrl = '/dashboard'; // this url will open after login
